import { Fragment } from 'react';
import { TrendingUpIcon } from 'lucide-react';

import type { FooterPart } from '../meterFooter';

/**
 * The meter's last line (spec 231 FR-002): where the period is heading and when the
 * limit renews, as one line of sentences under the figure they qualify. They used to
 * be two loose paragraphs between the meter and the next card — a forecast with an
 * icon and a renewal spelling out a midnight nobody needed.
 *
 * Separators are hidden below `sm`, so a phone wraps at a sentence boundary and
 * never shows a dangling dot (FR-007).
 */
export function MeterFooter({ parts }: { parts: readonly FooterPart[] }) {
  if (parts.length === 0) return null;

  return (
    <p
      data-testid="meter-footer"
      className="text-muted-foreground flex flex-wrap items-start gap-x-2 gap-y-0.5 text-sm"
    >
      <TrendingUpIcon
        aria-hidden="true"
        className="mt-0.5 size-4 shrink-0"
        strokeWidth={1.5}
      />
      {parts.map((part, index) => (
        <Fragment key={part.before}>
          {index > 0 ? (
            <span aria-hidden="true" className="max-sm:hidden">
              {' · '}
            </span>
          ) : null}
          <span>
            {part.before}
            {part.money !== undefined ? (
              <span className="text-foreground font-medium tabular-nums">
                {part.money}
              </span>
            ) : null}
            {part.after}
          </span>
        </Fragment>
      ))}
    </p>
  );
}
